// src/utils/firebaseConfig.js
import { sendPasswordResetEmail } from "firebase/auth";
import { setPersistence, browserLocalPersistence } from "firebase/auth";
import { updateProfile } from "firebase/auth";
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, createUserWithEmailAndPassword, signInWithEmailAndPassword, sendEmailVerification } from "firebase/auth";
import { signOut } from "firebase/auth";
import { getFirestore, collection, addDoc } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBG24fOWRsVIfLVrVA9H_cYs095bg8awao",
  authDomain: "trvllr-3838e.firebaseapp.com",
  projectId: "trvllr-3838e",
  storageBucket:  "trvllr-3838e.firebasestorage.app",
  messagingSenderId: "774218111334",
  appId: "1:774218111334:web:e8463da9824b66017dd0a7",
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
// Firestore Functions
export { db, collection, addDoc };
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
// Set session persistence
setPersistence(auth, browserLocalPersistence)
  .then(() => {
    console.log("Session Persistence Enabled");
  })
  .catch((error) => {
    console.error("Persistence Error:", error);
  });
// Add these functions for email/password authentication
export const signUpWithEmail = (email, password) => {
  return createUserWithEmailAndPassword(auth, email, password);
};
export const signInWithEmail = (email, password) => {
  return signInWithEmailAndPassword(auth, email, password);
};
export const sendVerificationEmail = async (user) => {
  if (user) {
    await sendEmailVerification(user);
    console.log("Verification email sent!");
  }
};
export const resetPassword = async (email) => {
  try {
    await sendPasswordResetEmail(auth, email);
    alert("Password reset email sent! Check your inbox.");
  } catch (error) {
    console.error("Error resetting password:", error);
    alert("Error: " + error.message);
  }
};
export const logoutUser = async () => {
  try {
    await signOut(auth);
    window.location.href = "/signin"; // Redirect user to Sign In
  } catch (error) {
    console.error("Logout Error:", error);
  }
};
